import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { Link } from "react-router-dom";
import Form from "./Form";
import Modal from "react-bootstrap/Modal";

const Cart = (props) => {
  const { cart, clearCart, clearProducto } = useContext(CartContext);

  // Función para mensaje directo sin productos
  const mensajeDirecto = () => {
    const plataforma = window.innerWidth < 990 ? "api" : "web";
    const telefono = "5493774411192";
    const texto = encodeURIComponent(
      "Hola *Optimarket OK!* 👓 Necesito asesoramiento general.",
    );
    window.open(
      `https://${plataforma}.whatsapp.com/send?phone=${telefono}&text=${texto}`,
      "_blank",
    );
  };

  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleModal}
        backdrop={true}
        keyboard={false}
        size="md"
        style={{
          borderRadius: "0",
          zIndex: 1000000,
        }}
        dialogClassName="modal-dialog-cart"
        backdropClassName="modal-backdrop-cart"
        contentClassName="modal-content-cart"
      >
        <Modal.Body>
          <div className="cart mt-3">
            {cart.length === 0 ? (
              /* --- VISTA CARRITO VACÍO --- */
              <div className="d-flex flex-column align-items-center text-center py-4">
                <h2 className="mb-4">¡Tu carrito está vacío!</h2>
                <p className="mb-4 text-muted">
                  Podés mirar nuestro catálogo para elegir el que más te guste o
                  mandarnos un mensaje.
                </p>

                <div className="w-100 d-flex flex-column gap-3">
                  <Link
                    to="/"
                    onClick={props.handleModal}
                    className="boton d-flex justify-content-center align-items-center w-100"
                    style={{ minHeight: "50px", textDecoration: "none" }}
                  >
                    Ver Catálogo <i className="bi bi-shop ms-2"></i>
                  </Link>

                  <div
                    className="boton btnWhat d-flex justify-content-center align-items-center w-100"
                    onClick={mensajeDirecto}
                    style={{ cursor: "pointer", minHeight: "50px" }}
                  >
                    Mensaje Directo <i className="bi bi-whatsapp ms-2"></i>
                  </div>
                </div>
              </div>
            ) : (
              /* --- VISTA CON PRODUCTOS --- */
              <>
                <h1 className="text-center text-md-start mb-4">
                  {" "}
                  Productos seleccionados{" "}
                </h1>

                <div
                  className="cart-items-container"
                  style={{ maxHeight: "45vh", overflowY: "auto" }}
                >
                  {cart.map((producto) => (
                    <div key={producto.id} className="mb-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <div style={{ fontSize: "0.9rem" }}>
                          <strong className="d-block">{producto.titulo}</strong>
                          <span className="text-muted">
                            {producto.categoria} / ${producto.precio}
                          </span>
                        </div>
                        <button
                          className="btn text-danger p-2"
                          onClick={() => clearProducto(producto.id)}
                        >
                          <i
                            className="bi bi-trash"
                            style={{ fontSize: "1.2rem" }}
                          ></i>
                        </button>
                      </div>
                      <hr className="my-2" />
                    </div>
                  ))}
                </div>

                <div className="botonera mt-4 d-flex flex-column gap-3">
                  {/* Botón para volver al catálogo */}
                  <Link
                    to="/"
                    onClick={props.handleModal}
                    className="boton d-flex justify-content-center align-items-center w-100"
                    style={{ minHeight: "50px", textDecoration: "none" }}
                  >
                    + Agregar más modelos
                  </Link>

                  {/* Componente Form que tiene el botón de WhatsApp final */}
                  <Form
                    cart={cart}
                    handleModal={props.handleModal}
                    clearCart={clearCart}
                  />
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Cart;
